<style lang="scss" scoped>
.admincontainer {
  padding: 0;
  display: flex;
  a {
    text-decoration: none;
    text-align: center;
    margin-right: -1px;
  }

  .button.router-link-active {
    background-color: $c-dark-blue;
    color: $c-light-grey;
    border-color: $c-dark-blue;
  }
}
</style>

<template>
  <div class="admincontainer">
    <router-link class="button" tag="li" :to="{ name: 'AdminAbteilungen' }">Abteilungen</router-link>
    <router-link class="button" tag="li" :to="{ name: 'AdminBenutzer' }">Benutzer:innen</router-link>
    <router-link class="button" tag="li" :to="{ name: 'AdminFeedback' }">Einschätzungen</router-link>
    <router-link class="button" tag="li" :to="{ name: 'AdminSkills' }">Skills</router-link>
    <router-link class="button" tag="li" :to="{ name: 'AdminUmfragen' }">Umfragen</router-link>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({});
</script>
